// extracted by mini-css-extract-plugin
export default {"form_profile":"Profile_form_profile__8H7uB","button_section":"Profile_button_section__MZ6iN"};